import { useState, useEffect, useCallback, useRef } from 'react';
import { fetchNotifications, fetchUnreadCount, markAsRead, markAllAsRead } from '../services/notificationsApi';

const POLL_INTERVAL = 30000; // 30s

export function useNotifications() {
    const [notifications, setNotifications] = useState([]);
    const [unreadCount, setUnreadCount] = useState(0);
    const [loading, setLoading] = useState(false);
    const intervalRef = useRef(null);

    const refreshCount = useCallback(async () => {
        try {
            const count = await fetchUnreadCount();
            setUnreadCount(count);
        } catch { /* silently fail */ }
    }, []);

    const loadNotifications = useCallback(async () => {
        setLoading(true);
        try {
            const data = await fetchNotifications({ limit: 30 });
            setNotifications(data);
        } catch { /* silently fail */ }
        setLoading(false);
    }, []);

    const handleMarkRead = useCallback(async (id) => {
        try {
            await markAsRead(id);
            setNotifications(prev => prev.map(n => n.id === id ? { ...n, read_at: new Date().toISOString() } : n));
            setUnreadCount(prev => Math.max(0, prev - 1));
        } catch { /* silently fail */ }
    }, []);

    const handleMarkAllRead = useCallback(async () => {
        try {
            await markAllAsRead();
            setNotifications(prev => prev.map(n => ({ ...n, read_at: n.read_at || new Date().toISOString() })));
            setUnreadCount(0);
        } catch { /* silently fail */ }
    }, []);

    // Poll unread count
    useEffect(() => {
        refreshCount();
        intervalRef.current = setInterval(refreshCount, POLL_INTERVAL);
        return () => clearInterval(intervalRef.current);
    }, [refreshCount]);

    return {
        notifications,
        unreadCount,
        loading,
        loadNotifications,
        handleMarkRead,
        handleMarkAllRead,
        refreshCount,
    };
}
